"use client";
function d(r, a, n = !0) {
  return r.filter((e) => {
    var t;
    return e.parentId === a && (!n || ((t = e.context) == null ? void 0 : t.open));
  }).flatMap((e) => [e, ...d(r, e.id, n)]);
}
function l(r, a) {
  var e;
  let n = [], i = (e = r.find((t) => t.id === a)) == null ? void 0 : e.parentId;
  for (; i; ) {
    const t = r.find((c) => c.id === i);
    i = t == null ? void 0 : t.parentId, t && (n = n.concat(t));
  }
  return n;
}
export {
  l as a,
  d as g
};
